export default __webpack_public_path__ + "static/media/planet.c80b4cee.svg";